import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Tournament, TournamentDivision, TournamentTeam } from '@mtgame/core';
import { getTeamPageRoute, getTournamentRoute } from '@config/routes';
import { DIVISION_QUERY_PARAM, SEASON_QUERY_PARAM, TOURNAMENT_QUERY_PARAM } from '@config/routing-map';

@Component({
  selector: 'mtg-division-standings',
  templateUrl: './division-standings.component.html',
  styleUrls: ['../shared/styles.scss', './division-standings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DivisionStandingsComponent implements OnChanges {
  @Input()
  tournament: Tournament;
  @Input()
  division: TournamentDivision;
  @Input()
  teams: TournamentTeam[];
  firstPlace: TournamentTeam;
  secondPlace: TournamentTeam;
  thirdPlace: TournamentTeam;

  get divisionQueryParams() {
    return {[DIVISION_QUERY_PARAM]: this.division.id.toString()};
  }

  get teamQueryParams() {
    return {};
    /*
    return {
      [SEASON_QUERY_PARAM]: this.tournament.season.id,
      [TOURNAMENT_QUERY_PARAM]: this.tournament.id,
    };*/
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.teams) {
      this.firstPlace = this.teams.find(item => item.finalStanding === 1);
      this.secondPlace = this.teams.find(item => item.finalStanding === 2);
      this.thirdPlace = this.teams.find(item => item.finalStanding === 3);
    }
  }

  getDivisionRoute(): string[] {
    return getTournamentRoute(this.tournament.alias);
  }

  getTeamRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }
}
